(()=>{
const SCRIPT = document.currentScript || document.querySelector('script[src*="promo-pilot-storefront"]');
const BASE = (() => {
  try {
    if (SCRIPT && SCRIPT.dataset && SCRIPT.dataset.base) return SCRIPT.dataset.base.replace(/\/$/, '');
    if (SCRIPT && SCRIPT.src) {
      const u = new URL(SCRIPT.src, window.location.href);
      return u.origin;
    }
  } catch(e) {}
  return 'https://promo.57.129.156.251.sslip.io';
})();

const SHOP_DOMAIN = (() => {
  try {
    if (SCRIPT && SCRIPT.dataset && SCRIPT.dataset.shop) return SCRIPT.dataset.shop;
    if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
  } catch(e) {}
  return '199da1-60.myshopify.com';
})();

console.log('[PromoPilot] Merchandising engine initialized. BASE:', BASE, 'SHOP:', SHOP_DOMAIN);

const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
const esc = s => String(s ?? '').replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[m]));
const event = (id, type) => fetch(BASE + '/api/storefront/events', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: new URLSearchParams({ rule_id: id, event: type }).toString(), keepalive: true, mode: 'cors' }).catch(() => {});

function css(){
  if($('#pp-style')) return;
  const s = document.createElement('style');
  s.id = 'pp-style';
  s.textContent = `
    /* === Amazon / TikTok Shop Unified Deal Card === */
    .pp-unified-deal-card {
      background: #ffffff !important;
      border: 1px solid #fecaca !important;
      border-radius: 10px !important;
      overflow: hidden !important;
      margin: 8px 0 12px 0 !important;
      box-shadow: 0 2px 8px rgba(220, 38, 38, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04) !important;
      width: 100% !important;
      box-sizing: border-box !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    }
    .pp-unified-deal-card * {
      box-sizing: border-box !important;
    }
    .pp-deal-header {
      background: linear-gradient(90deg, #991b1b 0%, #dc2626 60%, #b91c1c 100%) !important;
      color: #ffffff !important;
      padding: 6px 12px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      letter-spacing: 0.03em !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    }
    .pp-deal-header-left {
      display: flex !important;
      align-items: center !important;
      gap: 5px !important;
    }
    .pp-deal-flash-badge {
      text-transform: uppercase !important;
      color: #ffffff !important;
      font-weight: 700 !important;
      font-size: 11px !important;
      letter-spacing: 0.04em !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    }
    .pp-deal-header-right {
      display: flex !important;
      align-items: center !important;
      gap: 5px !important;
      color: #fef08a !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    }
    .pp-deal-header-right svg {
      flex-shrink: 0 !important;
      color: #fef08a !important;
    }
    .pp-deal-clock {
      font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace !important;
      font-weight: 700 !important;
      color: #fef08a !important;
      background: rgba(0, 0, 0, 0.28) !important;
      padding: 1.5px 5px !important;
      border-radius: 4px !important;
      letter-spacing: 0.5px !important;
    }
    .pp-deal-body {
      padding: 8px 12px !important;
      background: #fffcfc !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 5px !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    }
    .pp-deal-price-line {
      display: flex !important;
      align-items: baseline !important;
      gap: 8px !important;
      flex-wrap: wrap !important;
    }
    .pp-deal-price-current {
      color: #dc2626 !important;
      font-size: 1.08rem !important;
      font-weight: 700 !important;
      line-height: 1.15 !important;
      letter-spacing: -0.01em !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      font-variant-numeric: tabular-nums !important;
    }
    .pp-deal-price-original {
      color: #6b7280 !important;
      font-size: 0.88rem !important;
      font-weight: 500 !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    }
    .pp-deal-price-original s {
      text-decoration: line-through !important;
      color: #9ca3af !important;
    }
    .pp-deal-save-badge {
      background: #fef2f2 !important;
      color: #dc2626 !important;
      border: 1px solid #fecaca !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      padding: 2.5px 8px !important;
      border-radius: 9999px !important;
      text-transform: uppercase !important;
      letter-spacing: 0.02em !important;
      margin-left: auto !important;
      white-space: nowrap !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    }
    .pp-deal-points-line {
      font-size: 11px !important;
      color: #6f263d !important;
      display: flex !important;
      align-items: center !important;
      gap: 4px !important;
      line-height: 1.2 !important;
      padding-top: 3px !important;
      border-top: 1px dashed rgba(220, 38, 38, 0.14) !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    }
    .pp-deal-points-line strong {
      color: #6f263d !important;
      font-weight: 700 !important;
    }

    /* Hide legacy un-unified elements when Unified Card is active */
    .pp-has-unified-card .np-product-price-row {
      display: none !important;
    }
    .pp-has-unified-card #nxr-product-badge,
    .pp-has-unified-card .nxr-product-pill,
    .pp-has-unified-card [id$="-product-badge"] {
      display: none !important;
    }

    /* === Product Title (Amazon / TikTok Shop Clean Header) === */
    .np-product-detail h1 {
      font-size: 1.18rem !important;
      line-height: 1.3 !important;
      letter-spacing: -0.01em !important;
      font-weight: 600 !important;
      color: #111827 !important;
      margin: 0 0 4px 0 !important;
    }
    @media (min-width: 768px) {
      .np-product-detail h1 {
        font-size: 1.5rem !important;
      }
    }
    .np-wise-rating-placement {
      margin: 2px 0 6px 0 !important;
    }
    .np-colour-options {
      scrollbar-width: none !important;
      -ms-overflow-style: none !important;
    }
    .np-colour-options::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
    .np-size-options {
      gap: 6px !important;
    }
    .np-size-button {
      min-width: 44px !important;
      height: 35px !important;
      padding: 2px 8px !important;
      border-radius: 6px !important;
    }
    .np-size-button-uk {
      font-size: 0.74rem !important;
    }
    .np-size-button-eu {
      font-size: 0.60rem !important;
    }

    /* === Mobile Gallery & Swatches: Complete Single-Screen Fit === */
    @media (max-width: 768px) {
      .np-product {
        padding: 10px 14px 44px !important;
      }
      .np-product-grid {
        gap: 8px !important;
      }
      .np-product-gallery {
        display: block !important;
        position: relative !important;
      }
      .np-product-main-image {
        aspect-ratio: 1/1 !important;
        max-width: 360px !important;
        width: 100% !important;
        margin: 0 auto !important;
        background: #fbfaf8 !important;
        border: 1px solid #ebe7e0 !important;
        border-radius: 12px !important;
        overflow: hidden !important;
        position: relative !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
      .np-product-media {
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
      .np-product-media[hidden] {
        display: none !important;
      }
      .np-product-media img,
      .np-product-media video {
        width: 100% !important;
        height: 100% !important;
        max-width: 100% !important;
        max-height: 100% !important;
        object-fit: contain !important;
        object-position: center !important;
        padding: 6px 8px 16px !important;
        box-sizing: border-box !important;
        display: block !important;
      }
      /* Hide redundant vertical thumbnails on mobile so gallery + variations fit on 1 screen */
      .np-product-thumbs {
        display: none !important;
      }
      .np-gallery-counter {
        bottom: 8px !important;
        right: 8px !important;
        background: rgba(17, 24, 39, 0.78) !important;
        font-size: 10px !important;
        padding: 3px 8px !important;
        border-radius: 9999px !important;
      }
      .np-product-detail {
        padding-top: 4px !important;
      }
      .np-product-badges {
        margin-bottom: 3px !important;
        gap: 4px !important;
      }
      .np-product-eyebrow {
        margin: 0 0 2px 0 !important;
        font-size: 0.65rem !important;
      }
      .np-option-card {
        padding: 10px 12px !important;
        border-radius: 10px !important;
        margin-bottom: 8px !important;
      }
      .pp-deal-price-current {
        font-size: 1.05rem !important;
      }
      .np-colour-options {
        gap: 8px !important;
        padding: 2px 2px 4px !important;
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
      }
      .np-colour-options::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
      .np-colour-chip {
        flex: 0 0 48px !important;
        width: 48px !important;
        height: 48px !important;
        border-radius: 8px !important;
      }
      .np-size-options {
        gap: 6px !important;
      }
      .np-size-button {
        min-width: 44px !important;
        height: 35px !important;
        padding: 2px 8px !important;
        border-radius: 6px !important;
      }
      .np-size-button-uk {
        font-size: 0.74rem !important;
      }
      .np-size-button-eu {
        font-size: 0.60rem !important;
      }
      /* Hide clutter widgets on mobile (fit rating survey and quantity) */
      .np-fit-widget {
        display: none !important;
      }
      .np-qty-row {
        display: none !important;
      }
      .np-add-button {
        border-radius: 9999px !important;
        padding: 15px 20px !important;
        font-size: 0.85rem !important;
        font-weight: 800 !important;
        background: #111827 !important;
      }
    }

    /* === Mobile Sticky ATC Bar === */
    .np-mobile-sticky-atc {
      padding: 8px 14px !important;
      background: rgba(255, 255, 255, 0.98) !important;
      backdrop-filter: blur(16px) !important;
      -webkit-backdrop-filter: blur(16px) !important;
      border-top: 1px solid #e5e7eb !important;
      box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.12) !important;
    }
    .np-mobile-sticky-atc strong[data-np-mobile-price] {
      color: #dc2626 !important;
      font-weight: 700 !important;
      font-size: 0.95rem !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
      font-variant-numeric: tabular-nums !important;
      display: inline-flex !important;
      align-items: baseline !important;
      gap: 4px !important;
    }
    .pp-sticky-deal {
      color: #dc2626 !important;
      font-weight: 700 !important;
      font-size: 0.95rem !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
      font-variant-numeric: tabular-nums !important;
    }
    .pp-sticky-cut {
      color: #9ca3af !important;
      text-decoration: line-through !important;
      font-size: 0.78rem !important;
      font-weight: 500 !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
      opacity: 0.75 !important;
    }
    .pp-sticky-save {
      background: #fef2f2 !important;
      color: #b91c1c !important;
      border: 1px solid #fecaca !important;
      font-size: 9px !important;
      font-weight: 700 !important;
      padding: 1.5px 5px !important;
      border-radius: 4px !important;
      text-transform: uppercase !important;
      letter-spacing: 0.02em !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
    }
    .np-mobile-sticky-btn {
      border-radius: 9999px !important;
      background: #111827 !important;
      padding: 11px 22px !important;
      font-size: 0.78rem !important;
      letter-spacing: 0.06em !important;
      font-weight: 800 !important;
    }

    /* === Collection Cards Responsive Styling === */
    .np-card__price-row {
      display: flex !important;
      align-items: baseline !important;
      flex-wrap: wrap !important;
      gap: 3px 6px !important;
    }
    .pp-card-deal-price {
      font-size: 15px !important;
      font-weight: 800 !important;
      color: #dc2626 !important;
      line-height: 1.1 !important;
    }
    .pp-card-price-faded {
      font-size: 12px !important;
      color: #9ca3af !important;
      text-decoration: line-through !important;
      opacity: 0.75 !important;
    }
    .pp-card-save-badge {
      background: #fef2f2 !important;
      color: #b91c1c !important;
      border: 1px solid #fecaca !important;
      font-size: 9.5px !important;
      font-weight: 700 !important;
      padding: 1px 5px !important;
      border-radius: 4px !important;
      white-space: nowrap !important;
    }
  `;
  document.head.appendChild(s);
}

function productHandle(){
  const m = location.pathname.match(/\/products\/([^/?#]+)/);
  return m ? decodeURIComponent(m[1]).replace(/\/$/, '') : null;
}

function dealPricing(r, handle){
  const c = r.config || {};
  const tierPricing = c.tier_pricing || {};
  const products = r.products || [];

  // Prime automatic discount in background
  if(c.promo_code){
    try {
      fetch(`/discount/${encodeURIComponent(c.promo_code)}`, { mode: 'no-cors' }).catch(()=>{});
    } catch(e) {}
  }

  // 1. Single Product Page (PDP)
  if(handle){
    const hNorm = handle.toLowerCase().trim();
    const matchedProduct = products.find(p => {
      if (!p.handle) return false;
      const ph = p.handle.toLowerCase().trim();
      return ph === hNorm || hNorm.includes(ph) || ph.includes(hNorm);
    });

    const pricing = matchedProduct ? tierPricing[matchedProduct.id] : null;

    if(pricing && pricing.promo && pricing.retail){
      const retail = Number(pricing.retail);
      const promo = Number(pricing.promo);
      const savings = Math.max(0, retail - promo);
      const savingsPct = Math.round((savings / retail) * 100);
      const points = Math.floor(promo * 10);

      const applyPdp = () => {
        const npRow = $('.np-product-price-row');
        const npMobile = $('[data-np-mobile-price]');
        const detail = $('.np-product-detail');

        if(detail && !detail.classList.contains('pp-has-unified-card')){
          detail.classList.add('pp-has-unified-card');
        }

        // Render Unified Deal Card directly
        let dealCard = $(`.pp-unified-deal-card[data-pp-rule="${r.id}"]`);
        if(!dealCard && npRow){
          dealCard = document.createElement('div');
          dealCard.className = 'pp-unified-deal-card';
          dealCard.dataset.ppRule = r.id;
          dealCard.innerHTML = `
            <div class="pp-deal-header">
              <div class="pp-deal-header-left">
                <span class="pp-deal-flash-badge">⚡ ${esc(c.headline || '1-Day ForYou Sale')}</span>
              </div>
              <div class="pp-deal-header-right">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                <span>Ends in <strong class="pp-deal-clock pp-ticker-${r.id}">23h 59m 59s</strong></span>
              </div>
            </div>
            <div class="pp-deal-body">
              <div class="pp-deal-price-line">
                <span class="pp-deal-price-current">£${promo.toFixed(2)}</span>
                <span class="pp-deal-price-original">Was <s>£${retail.toFixed(2)}</s></span>
                <span class="pp-deal-save-badge">Save £${savings.toFixed(2)} (${savingsPct}% OFF)</span>
              </div>
              <div class="pp-deal-points-line">
                ★ Earn <strong>${points} Nexsus Points</strong> with this item
              </div>
            </div>
          `;
          npRow.insertAdjacentElement('beforebegin', dealCard);
          event(r.id, 'impression');
        }

        // Update mobile sticky ATC bar
        if(npMobile && !npMobile.querySelector('.pp-sticky-deal')){
          npMobile.innerHTML = `
            <span class="pp-sticky-deal">£${promo.toFixed(2)}</span>
            <s class="pp-sticky-cut">£${retail.toFixed(2)}</s>
            <span class="pp-sticky-save">-${savingsPct}%</span>
          `;
        }

        // Ensure Add to Bag button shows deal price
        const addBtn = $('.np-add-button');
        if(addBtn && !addBtn.disabled && !addBtn.textContent.includes(`£${promo.toFixed(2)}`)){
          addBtn.textContent = `Add to Bag — £${promo.toFixed(2)}`;
        }
      };

      applyPdp();
      setInterval(applyPdp, 400);

      // Smooth gallery scroll into view when tapping any variation colour
      if(!window.__ppGallerySyncAttached){
        window.__ppGallerySyncAttached = true;
        document.addEventListener('click', (e) => {
          const colourBtn = e.target.closest('[data-np-colour]');
          if(colourBtn){
            const gallery = document.querySelector('.np-product-main-image');
            if(gallery){
              const rect = gallery.getBoundingClientRect();
              if(rect.top < 50 || rect.bottom < 150){
                gallery.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
            }
          }
        });
      }
    }
  }

  // 2. Collection & Grid Pages
  const applyCollectionDeals = () => {
    for(const p of products){
      const pricing = tierPricing[p.id];
      if(!p.handle || !pricing) continue;
      const retail = Number(pricing.retail);
      const promo = Number(pricing.promo);
      const savings = Math.max(0, retail - promo);

      const links = $$(`a[href*="/products/${CSS.escape(p.handle)}"]`);
      for(const link of links){
        const card = link.closest('.np-card, product-card, .card-wrapper, .product-card, .grid__item') || link.parentElement;
        if(!card || card.querySelector(`.pp-card-deal-applied[data-pp-rule="${r.id}"]`)) continue;

        const npCardRow = card.querySelector('.np-card__price-row');
        if(npCardRow){
          npCardRow.classList.add('pp-card-deal-applied');
          npCardRow.dataset.ppRule = r.id;
          npCardRow.innerHTML = `
            <span class="pp-card-deal-price">£${promo.toFixed(2)}</span>
            <s class="pp-card-price-faded">£${retail.toFixed(2)}</s>
            <span class="pp-card-save-badge">Save £${savings.toFixed(2)}</span>
          `;
        }
      }
    }
  };

  applyCollectionDeals();
  setInterval(applyCollectionDeals, 1000);

  // Live 24-Hour Rolling Countdown Ticker
  const startMs = new Date(r.starts_at || '2026-10-04T00:00:00Z').getTime();
  const endMs = new Date(r.ends_at || '2026-10-14T23:59:59Z').getTime();
  const dayMs = 24 * 60 * 60 * 1000;

  const updateTickers = () => {
    const now = Date.now();
    if(now >= endMs){
      $$(`.pp-ticker-${r.id}`).forEach(el => el.textContent = 'Sale Ended');
      return;
    }
    const elapsed = Math.max(0, (now - startMs) % dayMs);
    const remainingMs = dayMs - elapsed;
    const totalSec = Math.floor(remainingMs / 1000);
    const h = String(Math.floor(totalSec / 3600)).padStart(2, '0');
    const m = String(Math.floor((totalSec % 3600) / 60)).padStart(2, '0');
    const s = String(totalSec % 60).padStart(2, '0');
    const display = `${h}h ${m}m ${s}s`;
    $$(`.pp-ticker-${r.id}`).forEach(el => el.textContent = display);
  };

  updateTickers();
  setInterval(updateTickers, 1000);
}

async function init(){
  css();
  let data;
  try {
    const url = `${BASE}/api/storefront/config?shop=${encodeURIComponent(SHOP_DOMAIN)}`;
    const res = await fetch(url, { mode: 'cors' });
    if(res.ok){
      data = await res.json();
    }
  } catch(e) {
    console.warn('[PromoPilot] Config fetch warning:', e);
  }

  if(!data || !data.rules){
    try {
      const res = await fetch(`${BASE}/api/storefront/config`, { mode: 'cors' });
      if(res.ok) data = await res.json();
    } catch(e) {}
  }

  if(!data || !data.rules) return;

  const handle = productHandle();
  console.log('[PromoPilot] Resolved product handle:', handle);

  for(const r of data.rules){
    if(r.config?.tier_pricing){
      dealPricing(r, handle);
    }
  }
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
})();
